export default __webpack_public_path__ + "static/section1-background-33540ea125dbd3d3082c197652d8af10.webp";